import {
  FaWifi,
  FaChair,
  FaBell,
  FaBath,
  FaToilet,
  FaUtensils,
  FaShieldAlt,
  FaBroom,
  FaUserNurse,
  FaDoorClosed,
  FaUserMd,
  FaBed,
} from "react-icons/fa";

import singleBed from "../../assets/images/wardImages/singleBed.webp";
import doubleBed from "../../assets/images/wardImages/doubleBed.webp";
import washRoom from "../../assets/images/wardImages/washroom.webp";

// Define a type for the icon component
type IconType = React.ComponentType<{ className?: string }>;

export interface RoomAmenity {
  name: string;
  icon: IconType;
}

export interface roomImages {
  description: string;
  image: any;
}
export interface ImportantNotes {
  description: string;
}

export interface WordsAndRooms {
  id: number;
  mainImage: any;
  image: roomImages[];
  location: string;
  roomType: string;
  roomSize: string;
  fromPrice: string;
  roomAmenities: RoomAmenity[];
  bathAndToiletries: RoomAmenity[];
  foodAndBeverage: RoomAmenity[];
  complimentaryServices: RoomAmenity[];
  additionalPaidServices: RoomAmenity[];
  importantNotes: ImportantNotes[];
}

export const wordsAndRooms: WordsAndRooms[] = [
  {
    id: 1,
    mainImage: singleBed,
    image: [
      {
        description:
          "A peaceful Ayurvedic hospital room featuring a single luxury bed, warm lighting, and soothing tones for holistic healing and rest.",
        image: singleBed,
      },
      { description: "Bathroom with premium bath amenities.", image: washRoom },
    ],
    location: "Ceylon Hospital",
    roomType: "Single Room",
    roomSize: "100sqft",
    fromPrice: "Rs. 4000.00  (USD 14)",
    roomAmenities: [
      { name: "Free WiFi", icon: FaWifi },
      { name: "Visitor chair", icon: FaChair },
      { name: "Medium-sized Cloth Cupboard", icon: FaDoorClosed },
      { name: "Nurse on Call", icon: FaBell },
    ],
    bathAndToiletries: [
      { name: "Private Bathroom", icon: FaBath },
      { name: "Basic Toiletries Provided", icon: FaToilet },
    ],
    foodAndBeverage: [{ name: "3 nourishing meals per day", icon: FaUtensils }],
    complimentaryServices: [
      { name: "24-Hour Security", icon: FaShieldAlt },
      { name: "Daily Housekeeping", icon: FaBroom },
      { name: "24-Hour Nursing Service", icon: FaUserNurse },
      { name: "24-Hour Doctor Availability", icon: FaUserMd },
    ],
    additionalPaidServices: [
      {
        name: "Meals (Breakfast, Lunch, Dinner): Rs. 1,500 per day",
        icon: FaUtensils,
      },
      {
        name: "Bystander Stay with 3 meals per day (24 Hours): Rs. 5,500 per day",
        icon: FaBed,
      },
    ],
    importantNotes: [
      {
        description:
          "Rates apply to room charges only. Treatment, medication, and meals are billed separately.",
      },
      { description: "Food charges are applicable for bystanders." },
      {
        description:
          "In the event of temporary discharge, all outstanding bills must be settled on the same day.",
      },
      { description: "Invoices are to be settled every 7 days." },
      { description: "A cost estimate will be provided upon admission." },
      {
        description:
          "If hospital charges exceed the initial deposit, an additional deposit will be requested.",
      },
      {
        description:
          "All prices listed are exclusive of VAT. VAT will be added to the final bill.",
      },
      { description: "Prices are subject to change without prior notice." },
    ],
  },

  {
    id: 2,
    mainImage: doubleBed,
    image: [
      {
        description:
          "A serene Ayurvedic room with a luxurious patient bed and bystander bed, offering comfort, healing, and refined natural ambience.",
        image: doubleBed,
      },
      { description: "Bathroom with premium bath amenities.", image: washRoom },
    ],
    location: "Ceylon Hospital",
    roomType: "Single Room (with bystander)",
    roomSize: "144sqft",
    fromPrice: "Rs. 5,000 (USD 17)",
    roomAmenities: [
      { name: "Free WiFi", icon: FaWifi },
      { name: "Visitor chair", icon: FaChair },
      { name: "Medium-sized Cloth Cupboard", icon: FaDoorClosed },
      { name: "Nurse on Call", icon: FaBell },
    ],
    bathAndToiletries: [
      { name: "Private Bathroom", icon: FaBath },
      { name: "Basic Toiletries Provided", icon: FaToilet },
    ],
    foodAndBeverage: [{ name: "3 nourishing meals per day", icon: FaUtensils }],
    complimentaryServices: [
      { name: "24-Hour Security", icon: FaShieldAlt },
      { name: "Daily Housekeeping", icon: FaBroom },
      { name: "24-Hour Nursing Service", icon: FaUserNurse },
      { name: "24-Hour Doctor Availability", icon: FaUserMd },
    ],
    additionalPaidServices: [
      {
        name: "Meals (Breakfast, Lunch, Dinner): Rs. 1,500 per day",
        icon: FaUtensils,
      },
      {
        name: "Bystander Stay with 3 meals per day (24 Hours): Rs. 5,500 per day",
        icon: FaBed,
      },
    ],
    importantNotes: [
      {
        description:
          "Rates apply to room charges only. Treatment, medication, and meals are billed separately.",
      },
      { description: "Food charges are applicable for bystanders." },
      {
        description:
          "In the event of temporary discharge, all outstanding bills must be settled on the same day.",
      },
      { description: "Invoices are to be settled every 7 days." },
      { description: "A cost estimate will be provided upon admission." },
      {
        description:
          "If hospital charges exceed the initial deposit, an additional deposit will be requested.",
      },
      {
        description:
          "All prices listed are exclusive of VAT. VAT will be added to the final bill.",
      },
      { description: "Prices are subject to change without prior notice." },
    ],
  },
];
